import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { server } from "../../../common";
import { useSelectAccess } from "../../../store/stateFunctions";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";

const AddBusiness = () => {
  const [initialValues, setInitialValues] = useState({
    shop_name: "",
    owner: "",
    mobile: "",
    email: "",
    details: "",
    address: "",
    landmark: "",
    city: "",
    pincode: "",
    location: "",
    url1: "",
    image: null,
    category: "",
    timing: "",
  });

  const user = useSelectAccess("Merchant");
  const [photoModal, setPhoto] = useState(false);
  const [profielphoto, setprofilephoto] = useState([]);
  const [orgdetails, setOrgDetails] = useState([]);
  const [profile, setProfile] = useState([]);
  const closePhotoModal = () => setPhoto(false);

  const navigate = useNavigate();
  useEffect(() => {
    getBusinessData();
  }, []);

  const isStatusSent = orgdetails.some(
    (data) => data.status === "Sent" || data.status === "Reviewed"
  );
  const isStatusreject = orgdetails.some((data) => data.status === "Rejected");

  const isOrganizationDetailsAvailable = orgdetails.some(
    (data) => data.status === "Approved"
  );

  // Get organisation details
  const getBusinessData = () => {
    server
      .get("/shopdetails/getshopdetails", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setOrgDetails(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      shop_name: Yup.string().required("Enter a Your Business Name"),
      owner: Yup.string().required("Enter a Owner name"),
      mobile: Yup.string().required("Enter a Contact Number"),
      email: Yup.string().required("Enter a Business Email Id"),
      details: Yup.string().required("Enter a Your Business Details"),
      address: Yup.string().required("Enter a Address"),
      landmark: Yup.string().required("Enter a Landmark"),
      city: Yup.string().required("Enter a City"),
      pincode: Yup.string().required("Enter a Pincode"),
      location: Yup.string().required("Enter a Google Location link"),
      category: Yup.string().required("Enter a business category"),
      timing: Yup.string().required("Enter a business timing"),
      url1: Yup.string().required("Enter a Business Website Link"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (!values.image) {
        toast.error("Please select a images for verification");
        return;
      }

      const formData = new FormData();
      formData.append("shop_name", values.shop_name);
      formData.append("owner", values.owner);
      formData.append("mobile", values.mobile);
      formData.append("email", values.email);
      formData.append("details", values.details);
      formData.append("address", values.address);
      formData.append("landmark", values.landmark);
      formData.append("city", values.city);
      formData.append("pincode", values.pincode);
      formData.append("location", values.location);
      formData.append("category", values.category);
      formData.append("timing", values.timing);
      formData.append("url1", values.url1);

      formData.append("image", values.image);

      server
        .post("/shopdetails/addshopdetails", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            toast.success("Details Sent successfully");
            formik.resetForm();
            navigate("/merchantprofile");
          }
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
        });
    },
  });
  return (
    <>
      <section>
        {!isOrganizationDetailsAvailable &&
          isStatusSent &&
          orgdetails.map((item) => {
            return (
              <div className="card p-2">
                <p>
                  <h5>Status:</h5>
                  <span>
                    Your Organization Details has been {item.status} please wait
                    for Approval.
                  </span>
                </p>
              </div>
            );
          })}

        {!isOrganizationDetailsAvailable &&
          isStatusreject &&
          orgdetails.map((item) => {
            return (
              <div className="card p-2">
                <p>
                  <h5>Status:</h5>
                  <span>
                    Your Organization Details has been {item.status} please Fill
                    Correct Data.
                  </span>
                </p>
              </div>
            );
          })}
        <div className="container-xl mb-2">
          {!isOrganizationDetailsAvailable && !isStatusSent && (
            <div className="multistep-form container p-5">
              <div>
                {/* <div className="row">
                  <div className="col-md-8">
                    <h1>
                      {isEditMode
                        ? "Edit Organization Details"
                        : "Add Organization Details"}
                    </h1>
                  </div>
                  <div className="col-md-4">
                    {orgdetails.map((data) => (
                      <button
                        className="banner text-white p-1 rounded-2 border-0 w-50"
                        key={data.id}
                        onClick={() => handleEditClick(data)}
                      >
                        Edit Business Details
                      </button>
                    ))}
                  </div>
                </div> */}

                <section>
                  <div className="container-xl mb-5">
                    <form
                      className="needs-validation d-flex flex-column gap-2"
                      onSubmit={formik.handleSubmit}
                    >
                      <div className="">
                        <h5 className="mb-3">Business Details</h5>
                        <div className="row">
                          <div className="col-md-6">
                            <TextField
                              name="shop_name"
                              margin="dense"
                              type="text"
                              value={formik.values.shop_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Shop Name"
                              variant="outlined"
                              label="Business Name"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">
                              {formik.errors.shop_name}
                            </p>
                          </div>

                          <div className="col-md-6 ">
                            <TextField
                              name="owner"
                              margin="dense"
                              type="text"
                              value={formik.values.owner}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Owner's Full Name"
                              variant="outlined"
                              label="Owner"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">{formik.errors.owner}</p>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-md-6">
                            <TextField
                              name="mobile"
                              margin="dense"
                              type="number"
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                              // disabled={!!props.edit}
                              onBlur={formik.handleBlur}
                              placeholder="Mobile Number"
                              variant="outlined"
                              label="Business Mobile Number"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">
                              {formik.errors.mobile}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <TextField
                              name="email"
                              margin="dense"
                              type="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Business Email"
                              variant="outlined"
                              label="Business Email"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">{formik.errors.email}</p>
                          </div>
                        </div>
                        <div className="">
                          <TextField
                            name="details"
                            margin="dense"
                            type="text"
                            value={formik.values.details}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Describe your business (min 200 chars)"
                            variant="outlined"
                            label="Business Details"
                            fullWidth
                            multiline
                            minRows={3}
                            required
                          ></TextField>
                          <p className="text-danger">{formik.errors.details}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 d-flex gap-3 align-items-center mb-2">
                          <label htmlFor="image data-name">
                            Organization/Institute Photos
                          </label>
                          <input
                            name="image"
                            type="file"
                            onChange={(event) => {
                              formik.setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              );
                            }}
                            // accept=".jpg,.png,.jpeg"
                          />
                          <p className="text-danger">{formik.errors.image}</p>
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-3">Address Details</h5>
                        <div>
                          <div className="row ">
                            <div className="col-md-6">
                              <TextField
                                name="address"
                                type="text"
                                margin="dense"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Address"
                                variant="outlined"
                                label="Address"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.address}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <TextField
                                name="landmark"
                                type="text"
                                margin="dense"
                                value={formik.values.landmark}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Near Natraj Society"
                                variant="outlined"
                                label="Landmark"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.landmark}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <TextField
                                name="city"
                                type="text"
                                margin="dense"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="City"
                                variant="outlined"
                                label="City"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.city}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <TextField
                                name="pincode"
                                type="number"
                                margin="dense"
                                value={formik.values.pincode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="412216"
                                variant="outlined"
                                label="pincode"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.pincode}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div>
                                <TextField
                                  name="location"
                                  type="text"
                                  margin="dense"
                                  value={formik.values.location}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  placeholder="Geo Location"
                                  variant="outlined"
                                  label="Business Geo Location Link"
                                  fullWidth
                                  required
                                ></TextField>
                                <p className="text-danger">
                                  {formik.errors.location}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div>
                                <TextField
                                  name="url1"
                                  type="text"
                                  margin="dense"
                                  value={formik.values.url1}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  placeholder="Website Url"
                                  variant="outlined"
                                  label="Website Url"
                                  fullWidth
                                  required
                                ></TextField>
                                <p className="text-danger">
                                  {formik.errors.url1}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <FormControl fullWidth required className="mb-2">
                                <InputLabel id="demo-simple-select-label">
                                  Category
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="category"
                                  variant="outlined"
                                  name="category"
                                  value={formik.values.category}
                                  onChange={formik.handleChange}
                                  required
                                >
                                  <MenuItem value="gym">Gym</MenuItem>
                                  <MenuItem value="cafe">Cafe</MenuItem>
                                  <MenuItem value="lodge">Lodge</MenuItem>
                                  <MenuItem value="bakery">Bakery</MenuItem>

                                  <MenuItem value="classes">Classes</MenuItem>
                                  <MenuItem value="library">Library</MenuItem>
                                  <MenuItem value="travel">Travels</MenuItem>
                                  <MenuItem value="loundry">Loundry</MenuItem>
                                  <MenuItem value="garage">Garage</MenuItem>
                                  <MenuItem value="medical">Medical</MenuItem>
                                  <MenuItem value="restaurants">
                                    Restaurants
                                  </MenuItem>
                                  <MenuItem value="stationary">
                                    Stationary
                                  </MenuItem>
                                  <MenuItem value="cyber_cafe">
                                    Cyber Cafe
                                  </MenuItem>
                                  <MenuItem value="event_decors">
                                    Event Decors
                                  </MenuItem>
                                  <MenuItem value="pg/hostels">
                                    PG/Hostels
                                  </MenuItem>

                                  <MenuItem value="doctor/clinic">
                                    Doctor/Clinics
                                  </MenuItem>
                                  <MenuItem value="mess/parcel">
                                    Mess/Parcel Point
                                  </MenuItem>
                                  <MenuItem value="salon/parlor">
                                    Saloon/Parlor
                                  </MenuItem>

                                  <MenuItem value="mobileshops">
                                    Mobile Shops
                                  </MenuItem>
                                  <MenuItem value="opticalstore">
                                    Optical Store
                                  </MenuItem>
                                  <MenuItem value="computer_hardware">
                                    Computer & Hardware Accessories
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>

                            <div className="col-md-6 mb-3">
                              <TextField
                                name="timing"
                                type="text"
                                value={formik.values.timing}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="412216"
                                variant="outlined"
                                label="Business Timing"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.pincode}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <span className="mb-1 d-block">
                          <input type="checkbox" name="" id="" /> &nbsp; All The
                          Above Information is Correct and If It Is Wrong Then I
                          Am Responsible For The Same.
                        </span>
                        <Button
                          className="banner text-white p-1 rounded-2 border-0 w-50"
                          type="submit"
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Conditionally render organization details */}
      {orgdetails.map(
        (data) =>
          data.status === "Approved" && (
            <div className="organization-details-container">
              <div className="row ">
                <div className="col-md-10">
                  <h2 className="organization-details-title">
                    Business Details
                  </h2>
                </div>
                <div className="col-md-2 text-end">
                  <NavLink
                    className="banner text-white p-1 rounded-2 border-0 "
                    to="/merchantprofile/editshopdetails"
                  >
                    Edit Details
                  </NavLink>
                </div>
              </div>
              <div className="row my-3 bg-light shadow-sm p-3">
                <div className="col-lg-6">
                  <div className=" mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Business Name :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.shop_name}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Business Email :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.email}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Owner Name :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.owner}</p>
                        </div>
                      </div>

                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Business Details :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.details}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Website :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">
                            <a href={data.url1}>{data.url1}</a>
                          </p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Category :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.category}</p>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className=" mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Working Hours :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.timing}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0"> Address :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.address}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0"> City :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.city}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Landmark : </p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.landmark}</p>
                        </div>
                      </div>

                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Location Link :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.address}</p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-0">Pincode :</p>
                        </div>
                        <div className="col-md-8">
                          <p className="text-muted mb-0">{data.pincode}</p>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
      )}
    </>
  );
};

export default AddBusiness;
